export default {
    'estimated_quotation': 'COTIZACIÓN ESTIMADA',
    urlBuses: '/',
}